const SearchIcon = ( { className } ) => {
	return (
		<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"
				 className={className}>
			<rect width="56" height="56" rx="16" fill="#85C553"/>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M26.6665 17.3334C21.5118 17.3334 17.3332 21.5121 17.3332 26.6667C17.3332 31.8214 21.5118 36.0001 26.6665 36.0001C31.8212 36.0001 35.9998 31.8214 35.9998 26.6667C35.9998 21.5121 31.8212 17.3334 26.6665 17.3334ZM14.6665 26.6667C14.6665 20.0393 20.0391 14.6667 26.6665 14.6667C33.2939 14.6667 38.6665 20.0393 38.6665 26.6667C38.6665 33.2942 33.2939 38.6667 26.6665 38.6667C20.0391 38.6667 14.6665 33.2942 14.6665 26.6667Z"
						fill="white"/>
			<path fillRule="evenodd" clipRule="evenodd"
						d="M33.3236 33.3239C33.8443 32.8032 34.6885 32.8032 35.2092 33.3239L40.9426 39.0572C41.4633 39.5779 41.4633 40.4221 40.9426 40.9428C40.4219 41.4635 39.5777 41.4635 39.057 40.9428L33.3236 35.2095C32.8029 34.6888 32.8029 33.8446 33.3236 33.3239Z"
						fill="white"/>
		</svg>
	
	
	);
};

export default SearchIcon;
